<template>
  <v-autocomplete
    outlined
    dense
    class="rounded-lg mt-1 mini-text field-edit"
    :label="keyValue"
    :clearable="true"
    :value="modelValue"
    :items="autocompleteItems"
    item-text="name"
    item-value="id"
    :hide-details="hideDetails"
    no-data-text="Нет результатов"
    @input="$emit('input',$event || null)"
    @click:clear="$emit('input', null)"
  />
</template>

<script>

export default {
  name: 'CommonAutocomplete',
  props: {
    modelValue: { type: String | null, required: true },
    hideDetails: {type: Boolean, default: false},
    keyValue: { type: String, required: true },

    autocompleteItems: { type: Array, default: () => [], required: false },
  },

}

</script>
